module.exports = __webpack_public_path__ + "img/dgzi.b9673dd2.png";